class MegaMenu {
  constructor(container) {
    this.container = container;
    this.leftMenuItems = this.container.querySelectorAll('.mega-menu__left li');
    this.rightMenus = this.container.querySelectorAll('.mega-menu__right-content');

    if (!this.leftMenuItems.length || !this.rightMenus.length) return;

    this.setDefaultActiveMenu();
    this.bindEvents();
  }

  setDefaultActiveMenu() {
    // Set the first left menu item as active by default
    this.leftMenuItems[0].classList.add('active');

    // Get the corresponding right menu and display it
    const targetId = this.leftMenuItems[0].getAttribute('trigger-to');
    const defaultRightMenu = this.container.querySelector(`[trigger-from="${targetId}"]`);
    if (defaultRightMenu) {
      defaultRightMenu.classList.add('active');
    }
  }

  bindEvents() {
    this.leftMenuItems.forEach((item) => {
      item.addEventListener('mouseenter', (event) => this.handleMouseEnter(event));
    });

    this.container.addEventListener('mouseleave', () => this.handleMouseLeave());
  }

  handleMouseEnter(event) {
    const targetItem = event.currentTarget;

    // Remove active class from all left menu items
    this.leftMenuItems.forEach((li) => li.classList.remove('active'));
    targetItem.classList.add('active');

    // Hide all right menu contents
    this.rightMenus.forEach((menu) => menu.classList.remove('active'));

    // Show the corresponding right menu content
    const targetId = targetItem.getAttribute('trigger-to');
    const targetMenu = this.container.querySelector(`[trigger-from="${targetId}"]`);
    if (targetMenu) {
      targetMenu.classList.add('active');
    }
  }

  handleMouseLeave() {
    // Remove active classes
    this.rightMenus.forEach((menu) => menu.classList.remove('active'));
    this.leftMenuItems.forEach((li) => li.classList.remove('active'));

    // Reapply default active state
    this.setDefaultActiveMenu();
  }
}

const megaMenus = document.querySelectorAll('.mega-menu__content');
megaMenus.forEach((menu) => new MegaMenu(menu));

// On hover megamenu open
function bindMouseOverToMegaMenu(item) {
  const content = item.querySelector('.mega-menu__content');
  if (!content) return;

  let openedOnHover = false;
  const closeMenu = () => {
    openedOnHover = false;
    item.removeAttribute('open');
    document.body.classList.remove('mega-menu-open');
  };

  item.addEventListener('mouseover', () => {
    if (!item.hasAttribute('open')) openedOnHover = true;
    item.setAttribute('open', true);
    document.body.classList.add('mega-menu-open');
  });

  // Hover opens the details before a pointer click; keep that first click from closing it.
  const summary = item.querySelector('summary');
  summary?.addEventListener('click', (event) => {
    if (event.detail === 0 || !openedOnHover || !item.hasAttribute('open')) return;
    event.preventDefault();
    openedOnHover = false;
    summary.setAttribute('aria-expanded', 'true');
  });
  item.addEventListener('toggle', () => {
    const isOpen = item.hasAttribute('open');
    if (!isOpen) openedOnHover = false;
    summary?.setAttribute('aria-expanded', String(isOpen));
    document.body.classList.toggle('mega-menu-open', Boolean(inlineMenu?.querySelector('details.mega-menu[open]')));
  });
  content.addEventListener('mouseover', () => item.setAttribute('open', true));
  content.addEventListener('mouseleave', closeMenu);
  item.addEventListener('mouseleave', closeMenu);
}

const inlineMenu = document.querySelector('.header__inline-menu');
inlineMenu?.querySelectorAll('details.mega-menu').forEach(bindMouseOverToMegaMenu);

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  inlineMenu?.querySelectorAll('details.mega-menu[open]').forEach((item) => item.removeAttribute('open'));
  document.body.classList.remove('mega-menu-open');
});
